<template>
    <Container>
        <div class="p-2.5 lg:h-24 flex flex-col justify-between -mt-12 overflow-hidden bg-gray-100 rounded-md shadow">
            <div class="lg:grid-cols-8 grid items-center flex-grow grid-cols-4">
                <div v-for="integration in integrations" class="animate-none flex flex-col items-center flex-grow space-y-4">
                    <img :src="integration.imagePath" class="h-7 w-7">
                    <div class="text-gray-body-400 font-medium text-center uppercase" style="font-size: 10px;">
                        {{ integration.name }}
                    </div>
                </div>
            </div>
        </div>
    </Container>
</template>

<script>
import Container from '../../../../shared/container.vue';

export default {
    components: {
        Container,
    },

    props: {
        integrations: {
            type: Array,
            required: true,
        },
    },
};
</script>
